import React from "react";
import "../styles/NavbarTop.css";
function NavbarTop() {
  return <></>;
}

export default NavbarTop;
